import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  activeRedemptionSearchRequest,
  historyRedemptionSearchRequest,
  setActiveRedemptionsEndDate,
  setActiveRedemptionsStartDate,
  setRedemptionsHistoryStatus,
  setRedemptionsHistoryStartDate,
  setRedemptionsHistoryEndDate,
  setRedemptionsHistoryTitle,
} from "../../../redux/actions/redemptions";
import { convertAmountToFrontend } from "../../../helpers/convert";
import moment from "moment";
import Button from "../../../components/Button";
import { Input, Select, Textarea } from "../../../components/Inputs";
import DataTable from "../../../components/DataTable";
import EmptyState from "../../../components/EmptyState/EmptyState";
import Loading from "../../../components/Loading/Loading";
import Modal from "../../../components/Modal/Modal";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import TitleValue from "../../../components/TitleValue/TitleValue";
import ModalCertificate from "../../../components/Modal/ModalCertificate";
import { API_PUT, API_DELETE, API_EXPORT } from "../../../helpers/api";
import { setNotification } from "../../../helpers/notification";
import ModalRedemption from "../../../components/Modal/ModalRedemption";
import ModalCancelledRedemption from "../../../components/Modal/ModalCancelledRedemption";
import { monthsAndResourceTypes } from "../../../constants/translations";
import fileDownload from "js-file-download";
import Pill from "../../../components/Pill";
import CountDownContainer from "../../../components/CountDownContainer";
import {
  getCitiesRequest,
  getDistrictsRequest,
} from "../../../redux/actions/geo";
import { sectorTypes } from "../../../constants/selects";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";
export default function RedemptionOperationsHistory({ t }) {
  const cities = useSelector((state) => state.geo.cities);
  const districts = useSelector((state) => state.geo.districts);
  const [selectedCity, setSelectedCity] = useState();
  const [selectedDistrict, setSelectedDistrict] = useState();
  const [selectedSector, setSelectedSector] = useState();
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const [activePage, setActivePage] = useState(0);
  const dispatch = useDispatch();
  const activeRedemptions = useSelector(
    (state) => state.redemptions.activeRedemptions
  );
  const authUser = useSelector((state) => state.authorization.user);

  const { items: historyRedemptions, total } = useSelector(
    (state) => state.redemptions.historyRedemptions
  );
  const activeLoading = useSelector((state) => state.redemptions.activeLoading);
  const historyLoading = useSelector(
    (state) => state.redemptions.historyLoading
  );
  const selectedOrganization = useSelector(
    (state) => state.authorization.user.organization
  );
  const activeStartDate = useSelector(
    (state) => state.redemptions.activeStartDate
  );
  const activeEndDate = useSelector((state) => state.redemptions.activeEndDate);
  const historyTitle = useSelector((state) => state.redemptions.historyTitle);
  const historyStartDate = useSelector(
    (state) => state.redemptions.historyStartDate
  );
  const historyEndDate = useSelector(
    (state) => state.redemptions.historyEndDate
  );
  const historyStatus = useSelector((state) => state.redemptions.historyStatus);
  const [inspectedRedemption, setInspectedRedemption] = useState();
  const [editedRedemption, setEditedRedemption] = useState();
  const [deletedRedemption, setDeletedRedemption] = useState();
  const [confirmEditRedemption, setConfirmEditRedemption] = useState(false);
  const [confirmDeleteRedemption, setConfirmDeleteRedemption] = useState(false);
  const [inspectedCertificate, setInspectedCertificate] = useState();
  const [requestLoading, setRequestLoading] = useState(false);
  const [inspectedCompletedRedemption, setInspectedCompletedRedemption] =
    useState();
  const [inspectedCancelledRedemption, setInspectedCancelledRedemption] =
    useState();
  const [historyRedemptionExportLoading, setHistoryRedemptionExportLoading] =
    useState(false);
  const [
    redemptionCertificateExportLoading,
    setRedemptionCertificateExportLoading,
  ] = useState(false);
  const [datePickerLimitations, setDatePickerLimitations] = useState({
    startPeriod: { min: "", max: "" },
    endPeriod: { min: "", max: "" },
  });
  const [downloadFilter, setDownloadFilter] = useState({});

  const activeRedemptionsColumns = [
    {
      name: t("pages.default.redemption.table.beneficiaryName"),
      selector: "beneficiaryName",
      sortable: true,
    },
    {
      name: t("pages.default.redemption.table.redemptionNo"),
      selector: "id",
      sortable: true,
    },
    {
      name: t("pages.default.redemption.table.transaction_date"),
      selector: "redemptionDate",
      sortable: true,
      cell: (row) => {
        return (
          <div>{moment(row.redemptionDate).format("DD.MM.YYYY HH:mm:ss")}</div>
        );
      },
    },
    {
      name: t("pages.default.redemption.table.documentCount"),
      selector: "documentCount",
      sortable: true,
      cell: (row) => convertAmountToFrontend(row?.documentCount),
    },
    {
      name: t("pages.default.redemption.table.inspect"),
      selector: "id",
      sortable: false,
      key: "inspect",
      cell: (row) => {
        return (
          <Button
            title={t("ui.default.review")}
            type="secondary"
            suffixIcon="search"
            onClick={() => inspectRedemption(row)}
          />
        );
      },
    },
    {
      name: t("pages.default.redemption.table.process"),
      selector: "id",
      sortable: false,
      width: "100px",
      key: "process",
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              title={t("ui.default.edit")}
              type="primary"
              disabled={
                authUser.organization.yekgOrganizationStatus === "PASSIVE" ||
                authUser.organization.yekgOrganizationStatus ===
                  "PARTIAL_PASSIVE"
              }
              suffixIcon="edit"
              onClick={() => editRedemption(row)}
            />
            <Button
              title={t("ui.default.delete")}
              type="destructive"
              disabled={
                authUser.organization.yekgOrganizationStatus === "PASSIVE" ||
                authUser.organization.yekgOrganizationStatus ===
                  "PARTIAL_PASSIVE"
              }
              suffixIcon="x"
              onClick={() => deleteRedemption(row)}
            />
          </div>
        );
      },
    },
    {
      name: t("pages.default.redemption.table.lastTimeToHandle"),
      selector: "lastTimeToHandle",
      sortable: true,
      cell: (row) => {
        return (
          <div>
            {" "}
            <CountDownContainer
              value={row.lastTimeToHandle}
            ></CountDownContainer>
          </div>
        );
      },
    },
  ];
  const historyRedemptionsColumns = [
    {
      name: t("pages.default.redemption.table.beneficiaryName"),
      selector: "beneficiaryName",
      sortable: true,
    },
    {
      name: t("pages.default.redemption.table.redemptionNo"),
      selector: "id",
      sortable: true,
    },
    {
      name: t("pages.default.redemption.table.transaction_date"),
      selector: "redemptionDate",
      sortable: true,
      cell: (row) => {
        return (
          <div>{moment(row.redemptionDate).format("DD.MM.YYYY HH:mm:ss")}</div>
        );
      },
    },
    {
      name: t("pages.default.redemption.table.documentCount"),
      selector: "documentCount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.documentCount);
      },
    },
    {
      name: t("pages.default.redemption.table.status"),
      selector: "redemptionStatus",
      sortable: true,
      cell: (row) => {
        return (
          <Pill
            label={t(`ui.default.codes.${row.redemptionStatus}`)}
            type={
              row.redemptionStatus === "COMPLETED" ? "success" : "important"
            }
          />
        );
      },
    },
    {
      name: t("pages.default.redemption.table.inspect"),
      selector: "id",
      sortable: false,
      key: "inspect",
      cell: (row) => {
        if (row.redemptionStatus === "COMPLETED") {
          return (
            <Button
              title={t("ui.default.review")}
              type="secondary"
              suffixIcon="search"
              onClick={() => inspectCompletedRedemption(row)}
            />
          );
        } else {
          return (
            <Button
              title={t("ui.default.review")}
              type="secondary"
              suffixIcon="search"
              onClick={() => inspectCancelledRedemption(row)}
            />
          );
        }
      },
    },
    {
      name: t("pages.default.redemption.table.process"),
      selector: "id",
      sortable: false,
      key: "process",
      cell: (row) => {
        return (
          row.redemptionStatus === "COMPLETED" && (
            <Button
              title={t("pages.default.redemption.table.download")}
              type="primary"
              suffixIcon="download"
              onClick={() => downloadRedemptionCertificate(row)}
              disabled={redemptionCertificateExportLoading}
            />
          )
        );
      },
    },
  ];
  const sectorTypeOptions = sectorTypes(t);

  const getCities = () => {
    dispatch(getCitiesRequest({}));
  };

  const translations = monthsAndResourceTypes(t);

  useEffect(() => {
    filterActiveRedemptions();
    filterOperationsHistory();
    getCities();
  }, []);

  useEffect(() => {
    dispatch(getDistrictsRequest({ cityId: selectedCity }));
  }, [selectedCity]);

  // useEffect(() => {
  //   editedRedemption && setSelectedDistrict(editedRedemption.district);
  // }, [districts]);

  // Start period - end Period min max Calculation
  useEffect(() => {
    let now = new Date();
    let sPMin, sPMax, ePMin, ePMax;
    let aprilOne = new Date(now.getFullYear(), 3, 1);
    let firstDayOfYear = new Date(now.getFullYear(), 0, 1);
    if (now >= aprilOne) {
      sPMin = new Date(now.getFullYear(), 0);
      ePMin = new Date(now.getFullYear(), 0);
    } else {
      if (now > firstDayOfYear) {
        sPMin = new Date(now.getFullYear() - 1, 0);
        ePMin = new Date(now.getFullYear() - 1, 0);
      } else {
        sPMin = new Date(now.getFullYear(), 0);
        ePMin = new Date(now.getFullYear(), 0);
      }
    }
    if (now.getDate() < 15) {
      sPMax = moment(now).subtract("2", "months");
      ePMax = moment(now).subtract("2", "months");
    } else {
      sPMax = moment(now).subtract("1", "months");
      ePMax = moment(now).subtract("1", "months");
    }
    setDatePickerLimitations({
      startPeriod: {
        min: moment(sPMin).format("YYYY-MM"),
        max: moment(sPMax).format("YYYY-MM"),
      },
      endPeriod: {
        min: moment(ePMin).format("YYYY-MM"),
        max: moment(ePMax).format("YYYY-MM"),
      },
    });
  }, []);

  const filterActiveRedemptions = () => {
    let startDate = activeStartDate.split("-");
    let endDate = activeEndDate.split("-");
    dispatch(
      activeRedemptionSearchRequest({
        organizationId: selectedOrganization
          ? selectedOrganization.organizationId
          : "",
        startMonth: startDate[1] ? parseInt(startDate[1]) : "",
        startYear: startDate[0] ? startDate[0] : "",
        endMonth: endDate[1] ? parseInt(endDate[1]) : "",
        endYear: endDate[0] ? endDate[0] : "",
      })
    );
  };

  const filterOperationsHistory = () => {
    let startDate = historyStartDate.split("-");
    let endDate = historyEndDate.split("-");
    const filters = {
      organizationId: selectedOrganization
        ? selectedOrganization.organizationId
        : "",
      title: historyTitle,
      status: historyStatus,
      startMonth: startDate[1] ? parseInt(startDate[1]) : "",
      startYear: startDate[0] ? startDate[0] : "",
      endMonth: endDate[1] ? parseInt(endDate[1]) : "",
      endYear: endDate[0] ? endDate[0] : "",
    };
    dispatch(
      historyRedemptionSearchRequest({
        ...filters,
      })
    );
    setDownloadFilter({
      ...filters,
    });
  };

  const downloadOperationsHistory = async () => {
    const {
      organizationId,
      title,
      status,
      startMonth,
      startYear,
      endMonth,
      endYear,
    } = downloadFilter;
    setHistoryRedemptionExportLoading(true);
    try {
      const res = await API_EXPORT("redemption/export/excel", {
        organizationId,
        title,
        redemptionStatus: status,
        consumptionStartMonth: startMonth,
        consumptionStartYear: startYear,
        consumptionEndMonth: endMonth,
        consumptionEndYear: endYear,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setHistoryRedemptionExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setHistoryRedemptionExportLoading(false);
    }
  };

  const filterChange = (e) => {
    switch (e.target.name) {
      case "activeRedemptionsStartDate":
        dispatch(setActiveRedemptionsStartDate(e.target.value));
        break;
      case "activeRedemptionsEndDate":
        dispatch(setActiveRedemptionsEndDate(e.target.value));
        break;
      case "historyRedemptionsTitle":
        dispatch(setRedemptionsHistoryTitle(e.target.value));
        break;
      case "historyRedemptionsStartDate":
        dispatch(setRedemptionsHistoryStartDate(e.target.value));
        break;
      case "historyRedemptionsEndDate":
        dispatch(setRedemptionsHistoryEndDate(e.target.value));
        break;
      case "historyRedemptionsStatus":
        dispatch(setRedemptionsHistoryStatus(e.target.value));
        break;
      default:
        break;
    }
  };

  const inspectRedemption = (row) => {
    setInspectedRedemption(row);
  };
  const inspectCompletedRedemption = (row) => {
    setInspectedCompletedRedemption(row);
  };
  const inspectCancelledRedemption = (row) => {
    setInspectedCancelledRedemption(row);
  };
  const closeInspectRedemption = () => {
    setInspectedRedemption();
  };

  const editRedemption = (row) => {
    // deep copy
    let redemption = JSON.parse(JSON.stringify(row));
    let startDate = moment(
      redemption.beneficiaryParty.consumptionStartTerm
    ).format("YYYY-MM");
    let endDate = moment(redemption.beneficiaryParty.consumptionEndTerm).format(
      "YYYY-MM"
    );

    setEditedRedemption({
      id: redemption.id,
      title: redemption.beneficiaryParty.title,
      taxOrIdentityNumber: redemption.beneficiaryParty.taxOrIdentityNumber,
      redemptionPurpose: redemption.beneficiaryParty.redemptionPurpose,
      beneficiaryPartyType: redemption.beneficiaryParty.beneficiaryPartyType,
      address: redemption.beneficiaryParty.address,
      description: redemption.description,
      city: cities.find((c) =>
        [c.name, c.value].includes(redemption.beneficiaryParty.city)
      ).value,
      district: redemption?.beneficiaryParty?.district,
      sector: redemption.beneficiaryParty.sector,
      startDate: startDate,
      endDate: endDate,
    });
    setSelectedCity(redemption.beneficiaryParty.city);
    setSelectedDistrict(redemption?.beneficiaryParty?.district);
    setSelectedSector(redemption.beneficiaryParty.sector);
  };

  const closeEditRedemption = () => {
    setEditedRedemption();
  };
  const editRedemptionChange = (e) => {
    if (e.target.name === "city") {
      setSelectedCity(e.target.value);
      setSelectedDistrict(null);
      dispatch(getDistrictsRequest({ cityId: e.target.value }));
    }
    if (e.target.name === "district") {
      setSelectedDistrict(e.target.value);
    }
    if (e.target.name === "sector") {
      setSelectedSector(e.target.value);
    }

    if (e.target.name === "startDate") {
      setEditedRedemption({
        ...editedRedemption,
        [e.target.name]: e.target.value,
      });
      let ePMin = e.target.value;
      setDatePickerLimitations({
        ...datePickerLimitations,
        endPeriod: { ...datePickerLimitations.endPeriod, min: ePMin },
      });
      return;
    }
    if (e.target.name === "endDate") {
      setEditedRedemption({
        ...editedRedemption,
        [e.target.name]: e.target.value,
      });
      let sPMax = e.target.value;
      setDatePickerLimitations({
        ...datePickerLimitations,
        startPeriod: { ...datePickerLimitations.startPeriod, max: sPMax },
      });
      return;
    }
    setEditedRedemption({
      ...editedRedemption,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (editedRedemption) {
      dispatch(getDistrictsRequest({ cityId: editedRedemption.city }));
    }
  }, [editedRedemption]);

  const validateEditRedemptionRequest = () => {
    if (!editedRedemption.title) {
      setNotification("error", t("pages.default.redemption.errors.fillTitle"));
      return false;
    }
    if (!editedRedemption.address) {
      setNotification("error", t("pages.default.redemption.errors.address"));
      return false;
    }
    if (!editedRedemption.city) {
      setNotification("error", t("pages.default.redemption.errors.city"));
      return false;
    }
    if (!selectedDistrict) {
      setNotification("error", t("pages.default.redemption.errors.district"));
      return false;
    }
    if (!editedRedemption.sector) {
      setNotification("error", t("pages.default.redemption.errors.sector"));
      return false;
    }
    if (!editedRedemption.startDate) {
      setNotification("error", t("pages.default.redemption.errors.startDate"));
      return false;
    }
    if (!editedRedemption.endDate) {
      setNotification("error", t("pages.default.redemption.errors.endDate"));
      return false;
    }
    return true;
  };
  const editRedemptionConfirmationToggle = () => {
    if (validateEditRedemptionRequest()) setConfirmEditRedemption(true);
  };
  const editRedemptionRequest = async () => {
    setRequestLoading(true);
    try {
      await API_PUT(`certificate/redemption/${editedRedemption.id}`, {
        description: editedRedemption.description,
        beneficiaryPartyRequest: {
          title: editedRedemption.title,
          taxOrIdentityNumber: editedRedemption.taxOrIdentityNumber,
          redemptionPurpose: editedRedemption.redemptionPurpose,
          beneficiaryPartyType: editedRedemption.beneficiaryPartyType,
          address: editedRedemption.address,
          city: cities?.find((item) => item.value === editedRedemption.city)
            ?.name,
          district: selectedDistrict,
          sector: editedRedemption.sector,
          consumptionStartYear: editedRedemption.startDate.split("-")[0],
          consumptionStartMonth: editedRedemption.startDate.split("-")[1],
          consumptionEndYear: editedRedemption.endDate.split("-")[0],
          consumptionEndMonth: editedRedemption.endDate.split("-")[1],
        },
      });
      setNotification("success", t("pages.default.redemption.editSuccess"));
      setConfirmEditRedemption(false);
      setEditedRedemption();
      filterActiveRedemptions();
      setRequestLoading(false);
    } catch (err) {
      setNotification("error", err.response.data.message);
      setRequestLoading(false);
    }
  };

  const deleteRedemption = (row) => {
    setDeletedRedemption(row);
    setConfirmDeleteRedemption(true);
  };
  const closeDeleteRedemption = (row) => {
    setDeletedRedemption();
    setConfirmDeleteRedemption(false);
  };
  const deleteRedemptionRequest = async () => {
    setRequestLoading(true);
    try {
      await API_DELETE(`certificate/redemption/${deletedRedemption.id}`);
      setNotification("success", t("pages.default.redemption.deleteSuccess"));
      setConfirmDeleteRedemption(false);
      setDeletedRedemption();
      filterActiveRedemptions();
      setRequestLoading(false);
    } catch (err) {
      setNotification("error", err.response.data.message);
      setRequestLoading(false);
    }
  };

  const downloadRedemptionCertificate = async (row) => {
    setRedemptionCertificateExportLoading(true);
    try {
      const res = await API_EXPORT(`redemption/export/pdf/${row.id}`);
      fileDownload(res.data, "cancellation-certificates.pdf");
      setRedemptionCertificateExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setRedemptionCertificateExportLoading(false);
    }
  };
  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    let startDate = historyStartDate.split("-");
    let endDate = historyEndDate.split("-");
    const filters = {
      organizationId: selectedOrganization
        ? selectedOrganization.organizationId
        : "",
      title: historyTitle,
      status: historyStatus,
      startMonth: startDate[1] ? parseInt(startDate[1]) : "",
      startYear: startDate[0] ? startDate[0] : "",
      endMonth: endDate[1] ? parseInt(endDate[1]) : "",
      endYear: endDate[0] ? endDate[0] : "",
      page: activePage,
      selector: selector,
      direction: direction,
    };
    dispatch(
      historyRedemptionSearchRequest({
        ...filters,
      })
    );
  };
  return (
    <>
      <h5 className="km__u--text-has-emphasis">
        {t("pages.default.redemption.redemptionOperationsHistoryTitle")}
      </h5>
      <div className="km__p--card">
        <div className="km__p--redemtion-title-container">
          <div className="km__p--redemption-title">
            {t("pages.default.redemption.activeOperations")}
          </div>
        </div>

        {activeRedemptions.length > 0 && !activeLoading && (
          <DataTable
            columns={activeRedemptionsColumns}
            data={activeRedemptions}
            rowKey={"id"}
            pagination
            paginationPerPage={10}
          />
        )}
        {activeRedemptions.length === 0 && !activeLoading && (
          <EmptyState
            icon="file-text"
            text={t("pages.default.redemption.activeNotFound")}
          />
        )}
        {activeLoading && (
          <Loading text={t("pages.default.redemption.activeLoading")} />
        )}
      </div>
      <div className="km__p--card">
        <div className="km__p--redemtion-title-container">
          <div className="km__p--redemption-title">
            {t("pages.default.redemption.operationsHistory")}
          </div>
        </div>
        <div className="km__p--redemption-operations-history-filter-container">
          <div className="km__p--redemption-operations-filters">
            <Input
              type="text"
              name="historyRedemptionsTitle"
              placeholder={t("pages.default.redemption.table.beneficiaryName")}
              value={historyTitle}
              onChange={filterChange}
            />
            <Input
              type="month"
              placement="bottom-end"
              name="historyRedemptionsStartDate"
              placeholder={t("pages.default.redemption.filter.startDate")}
              value={historyStartDate}
              max={historyEndDate}
              onChange={filterChange}
            />
            <Input
              type="month"
              placement="bottom-end"
              name="historyRedemptionsEndDate"
              placeholder={t("pages.default.redemption.filter.endDate")}
              value={historyEndDate}
              min={historyStartDate}
              onChange={filterChange}
            />
            <Select
              defaultValue={historyStatus}
              name="historyRedemptionsStatus"
              onChange={filterChange}
              options={[
                {
                  name: t("ui.default.allStatus"),
                  value: ["COMPLETED", "CANCELLED"],
                },
                { name: t("ui.default.Completed"), value: "COMPLETED" },
                { name: t("ui.default.Cancelled"), value: "CANCELLED" },
              ]}
            />
            <Button
              type="primary"
              label={t("ui.default.filter")}
              onClick={filterOperationsHistory}
            />
            <Button
              type="secondary"
              label={t("ui.default.download")}
              onClick={downloadOperationsHistory}
              suffixIcon="download"
              disabled={historyRedemptionExportLoading}
            />
          </div>
        </div>
        {historyRedemptions &&
          historyRedemptions.length > 0 &&
          !historyLoading && (
            // <DataTable
            //   columns={historyRedemptionsColumns}
            //   data={historyRedemptions}
            //   rowKey={"id"}
            //   pagination
            //   paginationPerPage={10}
            // />
            <DataTableServerSideRendering
              columns={historyRedemptionsColumns}
              data={historyRedemptions}
              rowKey="id"
              sortedColumn={sortedColumn}
              setSortedColumn={setSortedColumn}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
              pagination
              activePage={activePage}
              totalPageCount={total?.totalPageCount}
              handleFetchData={handleClick}
            />
          )}
        {historyRedemptions &&
          historyRedemptions.length === 0 &&
          !historyLoading && (
            <EmptyState
              icon="file-text"
              text={t("pages.default.redemption.historyNotFound")}
            />
          )}
        {historyLoading && (
          <Loading text={t("pages.default.redemption.historyLoading")} />
        )}
      </div>
      {inspectedRedemption && (
        <Modal
          isOpen={inspectedRedemption ? true : false}
          toggle={closeInspectRedemption}
        >
          <div className="km__p--redemption-inspect-modal">
            <div className="km__p--redemption-inspect-modal-header">
              <TitleValue
                title={t("pages.default.redemption.redemptionDate")}
                value={moment(inspectedRedemption.redemptionDate).format(
                  "DD.MM.YYYY HH:mm:SS"
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.redemption.table.beneficiaryName")}
                value={inspectedRedemption.beneficiaryParty.title}
                size="lg"
              />
            </div>
            <div className="km__p--redemption-inspect-modal-body">
              <div className="km__p--redemption-inspect-modal-title">
                {t("pages.default.redemption.inspectTitle")}
              </div>
              <div className="km__c--modal-certificate-body-table">
                <table>
                  <thead>
                    <tr>
                      <th>
                        {t("pages.default.certificates.table.stationName")}
                      </th>
                      <th>
                        {t("pages.default.certificates.table.resourceType")}
                      </th>
                      <th>
                        {t("pages.default.certificates.table.productionPeriod")}
                      </th>
                      <th>
                        {t("pages.default.certificates.table.documentCount")}
                      </th>
                      <th>{t("pages.default.certificates.table.inspect")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inspectedRedemption.redemptionDetails.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td>
                            {
                              item.yekgCertificateDto.productionData.station
                                .stationName
                            }
                          </td>
                          <td>
                            {
                              translations[
                                item.yekgCertificateDto.productionData
                                  .resourceType
                              ]
                            }
                          </td>
                          <td>
                            {
                              translations[
                                moment(
                                  item.yekgCertificateDto.productionData.term
                                ).format("M")
                              ]
                            }{" "}
                            /{" "}
                            {moment(
                              item.yekgCertificateDto.productionData.term
                            ).format("YYYY")}
                          </td>
                          <td>{item.amount}</td>
                          <td>
                            <Button
                              suffixIcon="search"
                              type="secondary"
                              onClick={() => setInspectedCertificate(item)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="km__p--redemption-inspect-modal-footer">
              <TitleValue
                title={t("pages.default.redemption.totalCertificateAmount")}
                value={convertAmountToFrontend(
                  inspectedRedemption.documentCount
                )}
                size="lg"
              />
              <Button
                type="primary"
                label={t("ui.default.close")}
                onClick={() => setInspectedRedemption()}
              />
            </div>
          </div>
        </Modal>
      )}
      {editedRedemption && (
        <Modal
          isOpen={editedRedemption ? true : false}
          toggle={closeEditRedemption}
        >
          <div className="km__p--redemption-edit-modal">
            <div className="km__p--redemption-edit-modal-header">
              {t("pages.default.redemption.updateRedemption")}
            </div>
            <div className="km__p--redemption-edit-modal-body">
              <Input
                label={t("pages.default.redemption.inputs.taxId")}
                value={editedRedemption.taxOrIdentityNumber}
                disabled
                id="popup-taxOrIdentityNumber"
              />
              <Input
                label={t("pages.default.redemption.inputs.title")}
                name="title"
                value={editedRedemption.title}
                onChange={editRedemptionChange}
                id="popup-title"
                disabled={
                  selectedOrganization?.yekgLicenseType === "K1" ||
                  selectedOrganization?.yekgLicenseType ===
                    "CHARGING_NETWORK_OPERATOR"
                }
              />
              <Select
                label={t("pages.default.redemption.inputs.redemptionPurpose")}
                name="redemptionPurpose"
                value={editedRedemption.redemptionPurpose}
                options={[
                  {
                    value: "IFSA_YESIL_TARIFE",
                    name: t(
                      "pages.default.redemption.options.IFSA_YESIL_TARIFE"
                    ),
                  },
                  {
                    value: "IFSA",
                    name: t("pages.default.redemption.options.IFSA"),
                  },
                ]}
                onChange={editRedemptionChange}
                disabled
                id="popup-redemptionPurpose"
              />
              <Select
                label={t("pages.default.redemption.inputs.beneficiaryType")}
                name="beneficiaryPartyType"
                value={editedRedemption.beneficiaryPartyType}
                options={[
                  {
                    name: t("pages.default.redemption.options.consumer"),
                    value: "CONSUMER",
                  },
                  {
                    name: t("pages.default.redemption.options.producer"),
                    value: "PRODUCER",
                  },
                ]}
                onChange={editRedemptionChange}
                disabled
                id="popup-beneficiaryPartyType"
              />
              <Textarea
                label={t("pages.default.redemption.inputs.address")}
                name="address"
                value={editedRedemption.address}
                onChange={editRedemptionChange}
                id="popup-address"
              />

              <Select
                options={cities}
                value={editedRedemption?.city}
                name="city"
                label={t("pages.default.redemption.inputs.city")}
                onChange={editRedemptionChange}
              />
              <Select
                value={editedRedemption?.district}
                options={[
                  {
                    value: null,
                    name: t("pages.default.redemption.inputs.select"),
                  },
                  ...districts,
                ]}
                name="district"
                label={t("pages.default.redemption.inputs.district")}
                onChange={editRedemptionChange}
              />

              <Select
                options={sectorTypeOptions}
                value={selectedSector}
                name="sector"
                label={t("pages.default.redemption.inputs.sector")}
                onChange={editRedemptionChange}
              />
              <Textarea
                label={t("pages.default.redemption.inputs.description")}
                name="description"
                value={editedRedemption.description}
                onChange={editRedemptionChange}
                id="popup-description"
                disabled={selectedOrganization?.yekgLicenseType === "K1"}
              />
              <div className="km__p--redemption-edit-modal-dates">
                <Input
                  label={t("pages.default.redemption.inputs.startPeriod")}
                  name="startDate"
                  type="month"
                  placement="top-start"
                  value={editedRedemption.startDate}
                  min={datePickerLimitations.startPeriod.min}
                  max={datePickerLimitations.startPeriod.max}
                  onChange={editRedemptionChange}
                  disabled={
                    editedRedemption.redemptionPurpose ===
                      "IFSA_YESIL_TARIFE" ||
                    selectedOrganization?.yekgLicenseType ===
                      "CHARGING_NETWORK_OPERATOR"
                      ? true
                      : false
                  }
                  id="popup-startDate"
                />
                <Input
                  label={t("pages.default.redemption.inputs.endPeriod")}
                  name="endDate"
                  type="month"
                  placement="top-end"
                  value={editedRedemption.endDate}
                  min={datePickerLimitations.endPeriod.min}
                  max={datePickerLimitations.endPeriod.max}
                  onChange={editRedemptionChange}
                  disabled={
                    editedRedemption.redemptionPurpose ===
                      "IFSA_YESIL_TARIFE" ||
                    selectedOrganization?.yekgLicenseType ===
                      "CHARGING_NETWORK_OPERATOR"
                      ? true
                      : false
                  }
                  id="popup-endDate"
                />
              </div>
            </div>
            <div className="km__p--redemption-edit-modal-footer">
              <Button
                label={t("ui.default.discard")}
                type="destructive"
                onClick={() => setEditedRedemption()}
                id="popup-cancel"
              />
              <Button
                label={t("ui.default.edit")}
                type="primary"
                onClick={editRedemptionConfirmationToggle}
                id="popup-edit"
              />
            </div>
          </div>
        </Modal>
      )}
      <ModalConfirmation
        isOpen={confirmEditRedemption}
        toggle={() => setConfirmEditRedemption(!confirmEditRedemption)}
        header={t("pages.default.redemption.modals.edit.title")}
        body={t("pages.default.redemption.modals.edit.description")}
        approve={() => editRedemptionRequest()}
        loading={requestLoading}
      />
      <ModalConfirmation
        isOpen={confirmDeleteRedemption}
        toggle={closeDeleteRedemption}
        header={t("pages.default.redemption.modals.delete.title")}
        body={t("pages.default.redemption.modals.delete.description")}
        approve={() => deleteRedemptionRequest()}
        loading={requestLoading}
      />
      {inspectedCertificate && (
        <ModalCertificate
          t={t}
          amount={inspectedCertificate.amount}
          certificateId={inspectedCertificate.yekgCertificateDto.id}
          isOpen={inspectedCertificate ? true : false}
          toggle={() => setInspectedCertificate()}
          difCalculate={true}
        />
      )}
      {inspectedCompletedRedemption && (
        <ModalRedemption
          t={t}
          redemptionDetail={inspectedCompletedRedemption}
          isOpen={inspectedCompletedRedemption ? true : false}
          toggle={() => setInspectedCompletedRedemption()}
        />
      )}
      {inspectedCancelledRedemption && (
        <ModalCancelledRedemption
          t={t}
          redemptionDetail={inspectedCancelledRedemption}
          isOpen={inspectedCancelledRedemption ? true : false}
          toggle={() => setInspectedCancelledRedemption()}
        />
      )}
    </>
  );
}
